import gql from 'graphql-tag';

export const getLateCourses = gql`
  query getLateCourses($career: String!, $period: String!) {
    LateCourses(career: $career, period: $period) {
      id
      name
      courseCatalog
      numberClass
      turn
      maxDate
      exams {
        id
        name
        requiredPayment
      }
    }
  }
`;
export const registerLateCourses = gql`
  mutation registerLateCourses(
    $procedureId: Float!
    $courseCatalog: String!
    $courseId: String!
    $period: String!
    $assessmentType: String!
    $assessmentTypeDesc: String!
    $courseDescription: String!
    $requirePayment: Boolean!
    $numberClass: String!
    $turn: String!
    $startDate: String!
  ) {
    registerLateCourses(
      request: {
        procedureId: $procedureId
        courseCatalog: $courseCatalog
        courseId: $courseId
        period: $period
        assessmentType: $assessmentType
        assessmentTypeDesc: $assessmentTypeDesc
        courseDescription: $courseDescription
        requirePayment: $requirePayment
        numberClass: $numberClass
        turn: $turn
        startDate: $startDate
      }
    ) {
      error
      requestId
    }
  }
`;

export const activatePaymentLateCourses = gql`
  mutation activatePaymentLateCourses($requestId: Float!) {
    activatePaymentLateCourses(requestId: $requestId) {
      error
      requestId
    }
  }
`;
